
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { UploadedDocument, State, FileCheckAttribute, UploadStatus as UploadStatus_3, Msg, SelectedFile, FileUploadStatus, FileValidationStatus } from "./Types.js";
import { DocumentFileCheck_DocumentFileCheckRequestDto, DocumentFileCheck_FileCheckAttribute } from "../../Shared/Importer.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, ValidationResponse, ClientApiResponse$1, PostResponse$1_$reflection, EmptyResponse_$reflection, PropertyConfigurationId__get_unwrap } from "../../Shared/Shared.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { forAll, exists, append, isEmpty, filter, collect, tryFind, map, singleton, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { PropertyConfigurationVisibility, PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { value as value_1, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { checkDocumentFilesCmd } from "../../Requests/Importer.js";

function createSelectedFile(file) {
    let copyOfStruct;
    return new SelectedFile((copyOfStruct = newGuid(), copyOfStruct), file, new FileValidationStatus(0, []), new FileUploadStatus(0, []));
}

function toServerFileCheckAttribute(attr) {
    switch (attr.tag) {
        case 1:
            return new DocumentFileCheck_FileCheckAttribute(1, []);
        case 2:
            return new DocumentFileCheck_FileCheckAttribute(2, [PropertyConfigurationId__get_unwrap(attr.fields[0].Id)]);
        default:
            return new DocumentFileCheck_FileCheckAttribute(0, []);
    }
}

function uploadDocumentCmd(fileId, entityId, entityType, file, isVisibleForUserRole) {
    const formData = new FormData();
    formData.append(file.name, file);
    formData.append("Name", file.name);
    formData.append("Description", "");
    formData.append("IsVisibleForUserRole", toString(isVisibleForUserRole));
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
    })))), [(entityType === "toolWithQuantity") ? concat("/api/tools/", entityId, ..."/files") : ((entityType === "consumable") ? concat("/api/consumables/", entityId, ..."/files") : ((entityType === "set") ? concat("/api/sets/", entityId, ..."/files") : concat("/api/tools/", entityId, ..."/files"))), formData], (response_1) => (new Msg(5, [fileId, new ClientApiResponse$1(0, [response_1])])), (_arg) => (new Msg(5, [fileId, new ClientApiResponse$1(1, [new ValidationResponse(undefined, empty())])])));
}

export function init() {
    return [new State(empty(), empty(), new UploadStatus_3(0, []), new FileCheckAttribute(1, []), new RequestedValue$1(0, []), FormState_get_empty(), false), Cmd_OfPromise_either_1((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix_1(url), (refreshOn) => fetchWithDecoder_1(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(PropertyConfiguration_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/property-configurations", (Item) => (new Msg(9, [Item])), (Item_1) => (new Msg(11, [Item_1])))];
}

function updateFileUploadStatus(fileId, status, files) {
    return map((sf) => {
        if (sf.Id === fileId) {
            return new SelectedFile(sf.Id, sf.File, sf.ValidationStatus, status);
        }
        else {
            return sf;
        }
    }, files);
}

function startNextFileUpload(files) {
    return defaultArg(map_1((sf_1) => singleton((dispatch) => {
        dispatch(new Msg(4, [sf_1.Id]));
    }), tryFind((sf) => {
        if (equals(sf.UploadStatus, new FileUploadStatus(0, []))) {
            if (sf.ValidationStatus.tag === 1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }, files)), singleton((dispatch_1) => {
        dispatch_1(new Msg(6, []));
    }));
}

function updateValidationStatus(response, files) {
    return collect((sf) => {
        const matchingResults = filter((r) => {
            if ((r.FileName === sf.File.name) && r.Found) {
                return r.EntityId != null;
            }
            else {
                return false;
            }
        }, response.Results);
        if (isEmpty(matchingResults)) {
            return singleton(new SelectedFile(sf.Id, sf.File, new FileValidationStatus(2, []), sf.UploadStatus));
        }
        else {
            return map((r_1) => {
                let copyOfStruct;
                return new SelectedFile((copyOfStruct = newGuid(), copyOfStruct), sf.File, new FileValidationStatus(1, [value_1(r_1.EntityId), defaultArg(r_1.EntityName, "-"), r_1.EntityType]), new FileUploadStatus(0, []));
            }, matchingResults);
        }
    }, files);
}

export function update(msg, state) {
    switch (msg.tag) {
        case 0: {
            const existingFileNames = ofList(map((sf) => sf.File.name, state.SelectedFiles), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const allFiles = append(state.SelectedFiles, map(createSelectedFile, filter((f) => !FSharpSet__Contains(existingFileNames, f.name), msg.fields[0])));
            return [new State(allFiles, allFiles, new UploadStatus_3(0, []), state.SelectedCheckAttribute, state.PropertyConfigurations, state.FormState, state.IsVisibleForUserRole), Cmd_none()];
        }
        case 1: {
            const updatedFiles = filter((sf_1) => (sf_1.Id !== msg.fields[0]), state.SelectedFiles);
            return [new State(updatedFiles, updatedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, state.FormState, state.IsVisibleForUserRole), Cmd_none()];
        }
        case 3:
            if (isEmpty(state.SelectedFiles)) {
                return [state, Cmd_none()];
            }
            else if (exists((sf_2) => {
                if (sf_2.ValidationStatus.tag === 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, state.SelectedFiles)) {
                const cmd = startNextFileUpload(state.SelectedFiles);
                return [new State(state.SelectedFiles, state.OriginSelectedFiles, new UploadStatus_3(1, []), state.SelectedCheckAttribute, state.PropertyConfigurations, FormState__startLoading(state.FormState), state.IsVisibleForUserRole), cmd];
            }
            else {
                return [state, Cmd_errorToast("importer.documents.no_valid_files_to_upload")];
            }
        case 4: {
            const fileId_1 = msg.fields[0];
            const file_1 = tryFind((sf_3) => (sf_3.Id === fileId_1), state.SelectedFiles);
            if (file_1 == null) {
                return [state, singleton((dispatch) => {
                    dispatch(new Msg(6, []));
                })];
            }
            else {
                const sf_4 = file_1;
                const matchValue_2 = sf_4.ValidationStatus;
                let matchResult, entityId, entityType;
                if (matchValue_2.tag === 1) {
                    if (matchValue_2.fields[2] != null) {
                        matchResult = 0;
                        entityId = matchValue_2.fields[0];
                        entityType = matchValue_2.fields[2];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return [new State(updateFileUploadStatus(fileId_1, new FileUploadStatus(1, []), state.SelectedFiles), state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, state.FormState, state.IsVisibleForUserRole), uploadDocumentCmd(fileId_1, entityId, entityType, sf_4.File, state.IsVisibleForUserRole)];
                    default:
                        return [state, startNextFileUpload(state.SelectedFiles)];
                }
            }
        }
        case 5: {
            const updatedFiles_2 = updateFileUploadStatus(msg.fields[0], (msg.fields[1].tag === 1) ? (new FileUploadStatus(3, [])) : (new FileUploadStatus(2, [])), state.SelectedFiles);
            return [new State(updatedFiles_2, state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, state.FormState, state.IsVisibleForUserRole), startNextFileUpload(updatedFiles_2)];
        }
        case 6: {
            const validFiles = filter((sf_5) => {
                if (sf_5.ValidationStatus.tag === 1) {
                    return true;
                }
                else {
                    return false;
                }
            }, state.SelectedFiles);
            if (forAll((sf_6) => equals(sf_6.UploadStatus, new FileUploadStatus(2, [])), validFiles) && !isEmpty(validFiles)) {
                return [new State(state.SelectedFiles, state.OriginSelectedFiles, new UploadStatus_3(2, [map((sf_8) => (new UploadedDocument(sf_8.File.name, sf_8.Id)), filter((sf_7) => equals(sf_7.UploadStatus, new FileUploadStatus(2, [])), state.SelectedFiles))]), state.SelectedCheckAttribute, state.PropertyConfigurations, FormState_get_empty(), state.IsVisibleForUserRole), Cmd_successToast("importer.documents.uploaded_success")];
            }
            else {
                return [new State(state.SelectedFiles, state.OriginSelectedFiles, new UploadStatus_3(0, []), state.SelectedCheckAttribute, state.PropertyConfigurations, FormState_get_empty(), state.IsVisibleForUserRole), Cmd_errorToast("importer.documents.upload_failed")];
            }
        }
        case 7: {
            const newState = new State(state.SelectedFiles, state.OriginSelectedFiles, state.UploadStatus, msg.fields[0], state.PropertyConfigurations, state.FormState, state.IsVisibleForUserRole);
            return [new State(map((sf_9) => (new SelectedFile(sf_9.Id, sf_9.File, new FileValidationStatus(0, []), sf_9.UploadStatus)), state.SelectedFiles), newState.OriginSelectedFiles, newState.UploadStatus, newState.SelectedCheckAttribute, newState.PropertyConfigurations, newState.FormState, newState.IsVisibleForUserRole), Cmd_none()];
        }
        case 8:
            return [new State(state.SelectedFiles, state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, state.FormState, msg.fields[0]), Cmd_none()];
        case 10: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.SelectedFiles, state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.IsVisibleForUserRole), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(updateValidationStatus(response_1.fields[0], state.SelectedFiles), state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, FormState_get_empty(), state.IsVisibleForUserRole), Cmd_successToast("general.saved_successfully")];
            }
        }
        case 9:
            return [new State(state.SelectedFiles, state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, new RequestedValue$1(1, [filter((pc) => {
                if (equals(pc.Visibility, new PropertyConfigurationVisibility(0, [])) && !pc.IsDeleted) {
                    if (pc.Type.tag === 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }, msg.fields[0])]), state.FormState, state.IsVisibleForUserRole), Cmd_none()];
        case 11:
            return [state, Cmd_none()];
        default: {
            const fileNames = map((_arg) => _arg.File.name, state.OriginSelectedFiles);
            const dto = new DocumentFileCheck_DocumentFileCheckRequestDto(toServerFileCheckAttribute(state.SelectedCheckAttribute), fileNames);
            return [new State(state.OriginSelectedFiles, state.OriginSelectedFiles, state.UploadStatus, state.SelectedCheckAttribute, state.PropertyConfigurations, FormState__startLoading(state.FormState), state.IsVisibleForUserRole), checkDocumentFilesCmd(dto, (Item) => (new Msg(10, [Item])), (Item_1) => (new Msg(11, [Item_1])))];
        }
    }
}

